module.exports = __webpack_public_path__ + "img/fmcs_wenshidu.0cfaa9b9.png";